App.SettingsImportController = Em.Controller.extend
	session: Em.inject.service()
	env:     Em.inject.service('environment')

	menu: null

	fileReaderIsSupported: !!window.FileReader

	isBoard2linkEnabled: Em.computed.alias('env.features.boardShowBoard2Link')